export default "__VITE_ASSET__cwA$SwcH__"